export default function Apiurl() {
  // const apiurl = "http://127.0.0.1:8000/api/";
  const apiurl = "https://cbcbackend.194.238.18.57.nip.io/api/";
  // const apiurl = "https://rishispectre.pythonanywhere.com/api/";

  return apiurl;
}
